import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.groups-apps.add-to-groups', {
        url: '/add-to-groups',
        views: {
            '@company.user-directories.manage-account': 'companyUserDirectoriesManageAccountGroupsAppsAddToGroups',
        },
        resolve: {
            groups,
        },
    });
}

/** @ngInject */
function groups(accountId, AccountsResource, companyId) {
    return AccountsResource.getAllGroupsUserCanBeAssignedTo(companyId, accountId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/groups-apps/add-to-groups/add-account-to-groups.state.js